module.exports = __webpack_public_path__ + "static/more-articles-mobile-4e92f2e3e60ac031c4615c76ffcdf7e8.png";